import MenuIcon from "@mui/icons-material/Menu";
import { Button, Drawer } from "@mui/material";
import * as React from "react";
import { useLocation } from "react-router-dom";

import Menu from "./index";

const HEADER_HEIGHT = 64;

export default function HamburguerMenu() {
  const [isOpen, setIsOpen] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <div>
      <Button onClick={() => setIsOpen(!isOpen)}>
        <MenuIcon
          fontSize="large"
          sx={{
            color: "var(--gray-900)",
          }}
        />
      </Button>
      <Drawer
        anchor="left"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: "17rem",
            backgroundColor: "var(--blue-200)",
            color: "var(--gray-100)",
            borderRight: 0,
            pt: `${HEADER_HEIGHT}px`,
            height: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            boxSizing: "border-box",
          },
        }}
      >
        <Menu collapsed={false} />
      </Drawer>
    </div>
  );
}
